var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnDecoration1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 130,
    viewBox: "0 0 118 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4889 111.351C93.1469 111.351 118 86.4246 118 55.6757C118 24.9268 93.1469 0 62.4889 0C31.8309 0 6.97754 24.9268 6.97754 55.6757C6.97754 86.4246 31.8309 111.351 62.4889 111.351ZM62.4889 91.1057C81.9985 91.1057 97.8142 75.2433 97.8142 55.6757C97.8142 36.1081 81.9985 20.2457 62.4889 20.2457C42.9792 20.2457 27.1635 36.1081 27.1635 55.6757C27.1635 75.2433 42.9792 91.1057 62.4889 91.1057Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDecoration1);
export default __webpack_public_path__ + "static/media/btn_decoration_1.5fbb4e7830bfe8bf28681cc87ae87e80.svg";
export { ForwardRef as ReactComponent };